import { AdReducerType } from "./ReduxTypes";


const CHANGE_AD_CLIENTS = "CHANGE_AD_CLIENTS";
const CHANGE_AD_ORGANIZATIONS = "CHANGE_AD_ORGANIZATIONS";
const CHANGE_AD_ADS = "CHANGE_AD_ADS";
const CHANGE_AD_ADGROUPNAMES = "CHANGE_AD_ADGROUPNAMES";
const CHANGE_AD_PROJECTS = "CHANGE_AD_PROJECTS";


const appReducerStore: AdReducerType = {
    clients: { ohgarden: { id: "ohgarden", name: "Oh!Garden AB" } },
    organizations: { ohgarden: { id: "ohgarden", name: "Oh!Garden AB" } },
    ads: {},
    adGroupNames: {},
    adProjects: {}
};


const adReducer = (state = { ...appReducerStore }, action) => {
    switch (action.type) {
        case CHANGE_AD_CLIENTS: { state = { ...state, clients: action.payload }; break; }
        case CHANGE_AD_ORGANIZATIONS: { state = { ...state, organizations: action.payload }; break; }
        case CHANGE_AD_ADS: { state = { ...state, ads: action.payload }; break; }
        case CHANGE_AD_ADGROUPNAMES: { state = { ...state, adGroupNames: action.payload }; break; }
        case CHANGE_AD_PROJECTS: { state = { ...state, adProjects: action.payload }; break; }

        default: { return state; }
    }
    return state;
};

export {
    adReducer,
    CHANGE_AD_CLIENTS,
    CHANGE_AD_ORGANIZATIONS,
    CHANGE_AD_ADS,
    CHANGE_AD_ADGROUPNAMES,
    CHANGE_AD_PROJECTS,
}